import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Section } from './ui/Section';
import { Clock } from 'lucide-react';
export function WeeklyClose() {
  return <Section bg="highlight" className="border-y border-warm-border" data-id="element-175">
      <FadeIn data-id="element-176">
        <div className="flex flex-col items-center text-center mb-10" data-id="element-177">
          <div className="p-3 bg-white rounded-full shadow-sm border border-warm-border mb-6" data-id="element-178">
            <Clock className="w-8 h-8 text-accent-teal" data-id="element-179" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-2" data-id="element-180">
            El Cierre Semanal de 12 minutos
          </h2>
          <p className="text-xl text-text-secondary font-serif italic" data-id="element-181">
            (la parte que te salva)
          </p>
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-182">
        <p className="text-lg mb-8 text-center max-w-lg mx-auto" data-id="element-183">
          Acá está la diferencia entre “lo intento” y “lo sostengo”. Una vez por
          semana, 12 minutos:
        </p>
      </FadeIn>

      <div className="grid gap-4 mb-10" data-id="element-184">
        {['Mirás lo que entró / lo que queda', 'Mirás qué vence', 'Tomás 3 decisiones', 'Programás 1–3 movimientos'].map((step, i) => <FadeIn key={i} delay={0.3 + i * 0.1} data-id="element-185">
            <div className="flex items-center gap-4 bg-white p-4 rounded-lg border border-warm-border shadow-sm" data-id="element-186">
              <div className="w-6 h-6 rounded-full border-2 border-accent-teal flex items-center justify-center" data-id="element-187">
                <div className="w-2 h-2 bg-accent-teal rounded-full" data-id="element-188"></div>
              </div>
              <span className="text-lg font-medium" data-id="element-189">{step}</span>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.6} data-id="element-190">
        <p className="text-2xl font-serif font-bold text-center text-text-primary" data-id="element-191">
          No necesitás motivación. Necesitás un guión.
        </p>
      </FadeIn>
    </Section>;
}